// Token utilities for handling authentication
export const tokenUtils = {
  // Get token from localStorage
  getToken: () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.accessToken || user.token || null;
  },

  // Check if token is expired
  isTokenExpired: (token) => {
    if (!token) return true;

    try {
      // If we have expiration info in user data
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.expiresAt) {
        return Date.now() > user.expiresAt;
      }

      // If token is JWT, decode and check exp
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp) {
        return Date.now() >= payload.exp * 1000;
      }
    } catch (error) {
      console.error('Error checking token expiration:', error);
      return true; // Assume expired if we can't check
    }

    return false;
  },

  // Clear all auth data
  clearAuth: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('auth');
  },

  // Redirect to login if not already there
  redirectToLogin: () => {
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }
};

export default tokenUtils;